import { GenericLazyString } from '@eventbrite/i18n';
import classnames from 'classnames';
import React, { FunctionComponent } from 'react';
import './text-expander-toggle.scss';

export interface TextExpanderToggleProps {
    ariaExpanded?: boolean;
    className?: string;
    onClick: () => void;
    text: string | GenericLazyString;
}

export const TextExpanderToggle: FunctionComponent<TextExpanderToggleProps> = ({
    ariaExpanded,
    className,
    onClick,
    text,
}) => (
    <button
        aria-expanded={ariaExpanded}
        className={classnames('eds-text-expander-toggle', className)}
        data-testid="eds-textExpander-toggle"
        onClick={onClick}
    >
        {text}
    </button>
);
